import { render, staticRenderFns } from "./EditSpendType.vue?vue&type=template&id=7899a9b0"
import script from "./EditSpendType.vue?vue&type=script&lang=js"
export * from "./EditSpendType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports